/** Legacy relocation From Bin options (pod-rfid-ui RelocationOut KitItemTable). */
export const RELOCATION_FROM_BINS = [
  'REPAIR',
  'MAJOR',
  'MINOR',
  'RDC',
  'DC',
  'CONDITION',
  'EXCESS REPAIR',
] as const;

export type RelocationFromBin = (typeof RELOCATION_FROM_BINS)[number];

export const DEFAULT_RELOCATION_FROM_BIN: RelocationFromBin = 'REPAIR';
